/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HydratedIntegrationFieldExistent
 */
export interface HydratedIntegrationFieldExistent {
    /**
     * 
     * @type {string}
     * @memberof HydratedIntegrationFieldExistent
     */
    fieldName: string;
    /**
     * 
     * @type {string}
     * @memberof HydratedIntegrationFieldExistent
     */
    displayName: string;
    /**
     * The field name to map to in the destination.
     * @type {string}
     * @memberof HydratedIntegrationFieldExistent
     */
    mapToName?: string;
    /**
     * The display name to map to in the destination.
     * @type {string}
     * @memberof HydratedIntegrationFieldExistent
     */
    mapToDisplayName?: string;
}

/**
 * Check if a given object implements the HydratedIntegrationFieldExistent interface.
 */
export function instanceOfHydratedIntegrationFieldExistent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "fieldName" in value;
    isInstance = isInstance && "displayName" in value;

    return isInstance;
}

export function HydratedIntegrationFieldExistentFromJSON(json: any): HydratedIntegrationFieldExistent {
    return HydratedIntegrationFieldExistentFromJSONTyped(json, false);
}

export function HydratedIntegrationFieldExistentFromJSONTyped(json: any, ignoreDiscriminator: boolean): HydratedIntegrationFieldExistent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fieldName': json['fieldName'],
        'displayName': json['displayName'],
        'mapToName': !exists(json, 'mapToName') ? undefined : json['mapToName'],
        'mapToDisplayName': !exists(json, 'mapToDisplayName') ? undefined : json['mapToDisplayName'],
    };
}

export function HydratedIntegrationFieldExistentToJSON(value?: HydratedIntegrationFieldExistent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fieldName': value.fieldName,
        'displayName': value.displayName,
        'mapToName': value.mapToName,
        'mapToDisplayName': value.mapToDisplayName,
    };
}

